
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g6NjTFVoPr8_4_5pKO6TG1EnjXhBtj_g47OVkm3nz3_45gMeta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexm0VIx0H8d1FTMPCFAsSwfX5SXfraZDEhUTUWa1rtvp8Meta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search8TMw048wngSKR2HfsUjdQasApTNGqlQyieTMFXK7YnMMeta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index6nZmpUqebD95jUl6uJIFJjvpsjHcckjl_45D3DT_2oEXkMeta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93y3isE1Z_45WDuZNdAPc866xq8_ca7jufF9AVQujLQj0oUMeta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexmEGI7P4Zy7_45xVrNtwskKY_r8wu8eUXBF7d_45YKwKFWe0Meta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93xDJiCJgxmYjMH06xEXjsCc92vRAooMpWJtDrZs2jQyUMeta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indext_45ojfOLO7_y_SEFvky5SPEHtRZthpqxn4UxE_UVQo7sMeta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93mAyf4a_T6qO_HyhpJ0a_2KDhmnA_Nf2QZKnRmnyvvd0Meta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index4p12cvRRgEFSl982hRt1zHNc2IrkzCiiuny93xjzIIgMeta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexMGjIURIaAdpDSMHNLa6DGl75wdKBtR7xGEvow_45mJpngMeta } from "/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexmEGI7P4Zy7_45xVrNtwskKY_r8wu8eUXBF7d_45YKwKFWe0Meta || {},
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indext_45ojfOLO7_y_SEFvky5SPEHtRZthpqxn4UxE_UVQo7sMeta || {},
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index4p12cvRRgEFSl982hRt1zHNc2IrkzCiiuny93xjzIIgMeta || {},
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexMGjIURIaAdpDSMHNLa6DGl75wdKBtR7xGEvow_45mJpngMeta || {},
    component: () => import("/codebuild/output/src475169432/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]